export default (str) => {
  const cleaned = ('' + str).replace(/(?!(?:[+]))\D+/g, '')
  
  const match = cleaned.match(/^(\+|)(\d{1}|)?(\d{3})(\d{3})(\d{4})$/)
  
  if (match) {
    const intlCode = (match[1] ? match[1] + match[2] : match[2])
    return [intlCode, ' (', match[3], ') ', match[4], '-', match[5]].join('')
  }
  
  return null
}
